__turbopack_context__.v({
  "homeReviewCard": "home-review-card-module-scss-module__LIYglq__homeReviewCard",
  "homeReviewCardFooter": "home-review-card-module-scss-module__LIYglq__homeReviewCardFooter",
  "homeReviewCardStars": "home-review-card-module-scss-module__LIYglq__homeReviewCardStars",
  "homeReviewCardText": "home-review-card-module-scss-module__LIYglq__homeReviewCardText",
});
